import { loadStripe } from "@stripe/stripe-js";

let _promise = null;
export function getStripe() {
  if (!_promise) {
    _promise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
  }
  return _promise;
}
